import { Avatar, Stack, Typography } from "@mui/material";
import React from "react";

function firstLetter(name: string) {
  const clubName = name.split(":")[0].trim();
  const letter = clubName.match(/[A-Za-z]/)?.[0];
  return (letter || clubName[0] || "?").toUpperCase();
}

export function ClubLogo({
  clubId,
  name,
  logo,
  size = 32,
}: {
  clubId: number;
  name: string;
  logo?: string | null;
  size?: number;
}) {
  return (
    <Avatar
      src={logo || undefined}
      alt={name + " logo"}
      data-testid={"club-logo-" + clubId}
      sx={{
        width: size,
        height: size,
        fontSize: size * 0.45,
        fontWeight: 700,
        bgcolor: logo ? "white" : "secondary.main",
        color: logo ? undefined : "primary.main",
        border: logo ? "1px solid rgba(0, 0, 0, 0.08)" : "none",
        "& img": { objectFit: "contain" },
      }}
    >
      {firstLetter(name)}
    </Avatar>
  );
}

export function ClubBadge({
  clubId,
  name,
  logo,
}: {
  clubId: number;
  name: string;
  logo?: string | null;
}) {
  return (
    <Stack direction="row" alignItems="center" gap={1} data-testid={"club-badge-" + clubId}>
      <ClubLogo clubId={clubId} name={name} logo={logo} size={28} />
      <Typography
        variant="body2"
        sx={{
          fontWeight: 600,
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
        }}
      >
        {name}
      </Typography>
    </Stack>
  );
}
